import { render, staticRenderFns } from "./VlboxResolutionField.vue?vue&type=template&id=a9299316&scoped=true"
import script from "./VlboxResolutionField.vue?vue&type=script&lang=js"
export * from "./VlboxResolutionField.vue?vue&type=script&lang=js"
import style0 from "./VlboxResolutionField.vue?vue&type=style&index=0&id=a9299316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9299316",
  null
  
)

export default component.exports